import { defineComponent as _defineComponent } from 'vue'
import { __ } from 'bits/intl'
import OzContainedButton, {
  OzContainedButtonColorScheme,
  OzContainedButtonSizePreset,
} from 'library/v4/components/OzContainedButton.vue'
import OzIconButton, { OzIconButtonColorScheme, OzIconButtonSizePreset } from 'library/v4/components/OzIconButton.vue'
import OzPadletLogo, { OzPadletLogoSizePreset } from 'library/v4/components/OzPadletLogo.vue'
import OzPlainButton, {
  OzPlainButtonColorScheme,
  OzPlainButtonSizePreset,
} from 'library/v4/components/OzPlainButton.vue'
import type { PopoverAnchor } from 'library/v4/components/OzPopoverModal.vue'
import { getAnchorFromElement } from 'library/v4/components/OzPopoverModal.vue'
import OzTabsWithSeparator, {
  OzTabsWithSeparatorAccessibilityRole,
  OzTabsWithSeparatorSizePreset,
} from 'library/v4/components/OzTabsWithSeparator.vue'
import { storeToRefs } from 'pinia'
import { LandsidePage, useLandsideNavigationStore } from 'pinia/landside_navigation'
import { useWindowSizeStore } from 'pinia/window_size'
import { computed, defineAsyncComponent, ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'LandsideHeader',
  setup(__props) {

const LandsideNavigationSidePanel = defineAsyncComponent(() => import('vuecomponents/LandsideNavigationSidePanel.vue'))
const LandsideNavigationPopover = defineAsyncComponent(() => import('vuecomponents/LandsideNavigationPopover.vue'))

const landsideNavigationStore = useLandsideNavigationStore()
const { isSmallerThanTabletPortrait, isSmallerThanDesktop3XL, isSmallerThanDesktop } = storeToRefs(useWindowSizeStore())
const { currentPage, landsidePages } = storeToRefs(landsideNavigationStore)

const xSidePanel = ref(false)
const xPopoverMenu = ref(false)
const menuAnchor = ref<Partial<PopoverAnchor>>({})
const navigationMenuButtonRef = ref<OzIconButton>()

const tabs = landsidePages.value.filter((page) => page.key !== LandsidePage.Home)
const currentPageTitle = computed(() => {
  const page = landsidePages.value.find((page) => page.key === currentPage.value)
  return page?.text
})
const xPageTitle = computed(() => {
  if (!isSmallerThanDesktop.value) return false
  return currentPage.value !== LandsidePage.Home
})

function openNavigationMenu(): void {
  if (isSmallerThanTabletPortrait.value) {
    xSidePanel.value = true
  } else if (isSmallerThanDesktop.value) {
    xPopoverMenu.value = true
    updateActionMenuAnchor()
  }
}

function updateActionMenuAnchor() {
  const menuButton = navigationMenuButtonRef.value?.$el
  if (!menuButton) return

  const anchor = getAnchorFromElement(menuButton, { top: 2, left: -12.25 })
  menuAnchor.value = {
    ...anchor,
    position: 'side',
  }
}

function handleSelectPage(page: LandsidePage) {
  landsideNavigationStore.setCurrentPage(page)
}

function handleActivateTab(_e, { key }: { key: LandsidePage }) {
  landsideNavigationStore.setCurrentPage(key)
}

const isHomePage = computed((): boolean => {
  return currentPage.value === LandsidePage.Home
})

return { __sfc: true,LandsideNavigationSidePanel, LandsideNavigationPopover, landsideNavigationStore, isSmallerThanTabletPortrait, isSmallerThanDesktop3XL, isSmallerThanDesktop, currentPage, landsidePages, xSidePanel, xPopoverMenu, menuAnchor, navigationMenuButtonRef, tabs, currentPageTitle, xPageTitle, openNavigationMenu, updateActionMenuAnchor, handleSelectPage, handleActivateTab, isHomePage, __, OzContainedButton, OzContainedButtonColorScheme, OzContainedButtonSizePreset, OzIconButton, OzIconButtonColorScheme, OzIconButtonSizePreset, OzPadletLogo, OzPadletLogoSizePreset, OzPlainButton, OzPlainButtonColorScheme, OzPlainButtonSizePreset, OzTabsWithSeparator, OzTabsWithSeparatorAccessibilityRole, OzTabsWithSeparatorSizePreset, LandsidePage }
}

})